import { render } from "./bk-selectBirthday.vue?vue&type=template&id=e1e33706"
import script from "./bk-selectBirthday.vue?vue&type=script&lang=js"
export * from "./bk-selectBirthday.vue?vue&type=script&lang=js"

import "./bk-selectBirthday.vue?vue&type=style&index=0&id=e1e33706&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__